



















import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import {State} from 'vuex-class';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import GridColumnsLayer from '@/components/common/claim/grid/GridColumnsLayer.vue';
import {i18nAllObject} from '@/utils/i18n';
import {changeDateFormat} from '@/utils/dateUtils';
import {writeExcel} from '@/utils/excel';
import {GridNameType} from 'supporter';

@Component({
  components: {CompSelectBox, GridColumnsLayer}
})
export default class ItemTable extends Vue {
  @Prop({ default: null })
  private readonly onItemClicked: (gridProp) => void;
  
  @Ref('tuiGrid')
  private readonly gridRef: Grid;
  
  // SA 있는 아이템 테이블 그대로 복붙
  @Prop() private option?: any;
  private initOver = false;
  private itemInfo = {
    name: 'grid',
    gridName: '',
    autoHeight: false,
    showTopcontent: true,
    nonDataBodyHeight: 190,
    haveDataBodyHeight: 480,
    haveRigthBtn: true,
    haveConfigBtn: true,
    havePageSizeBtn: true,
    haveExcelDownBtn: true,
    noBorder: false,
    onLoadSearch: true,
    excelDownInfo: null as any,
    pageSize: '30',
    pageSizes: [
      {
        value: '30',
        name: 'COMMON_PAGE_SIZE_30'
      },
      {
        value: '50',
        name: 'COMMON_PAGE_SIZE_50'
      },
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: '200',
        name: 'COMMON_PAGE_SIZE_200'
      }
    ]
  };

  private showColumns: any = [];
  private columnsOrder: any = [];
  private defaultColumnsOrder: any = [];
  private disabledCnt = 0;

  private showEditLayer = false;

  @Prop({required: true})
  private gridProps!: any;
  @Prop({required: true})
  private data!: [];
  @Prop({default: 0})
  private totalCount!: number;
  @Prop({required: true})
  private request!: any;


  @State private onGnb!: boolean;
  @Watch('onGnb')
  onGnbChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    if (grid) {
      grid.invoke('refreshLayout');
    }
  }

  private changePageSize(value: any) {
    this.$emit('resetData', 1, Number(value));
  }

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination') as any;
    if (!this.itemInfo.autoHeight) {
      grid.invoke('setBodyHeight', this.data.length === 0 ? this.itemInfo.nonDataBodyHeight : this.itemInfo.haveDataBodyHeight);
    }

    if (pagination) {
      const pageState = {
        totalCount: this.totalCount,
        page: this.gridProps.options.pageOptions.page,
        perPage: this.gridProps.options.pageOptions.perPage
      };
      grid.invoke('resetData', this.data as any, {pageState});
    } else {
      grid.invoke('resetData', this.data as any);
    }
    if (!this.data || this.data.length === 0) {
      grid.invoke('disable');
    } else {
      grid.invoke('enable');
    }
    this.$nextTick(() => {
      grid.invoke('refreshLayout');
    });
  }

  private excelDown() {
    if(this.totalCount >= 10000 ) {
      alert(this.$t('ORDER_LIST_GRIDS_EXCELDOWN_TOTAL'));
    }

    if (this.data && this.data.length > 0) {
      const excelColumns = this.showColumns.reduce((acc, column) => ({...acc, [column.name]: this.itemInfo.excelDownInfo.columns[column.name]}), {}) // TODO: 구리다
      const columns = i18nAllObject(this, excelColumns);

      let fileName = this.itemInfo.excelDownInfo.fileName;
      if (this.itemInfo.excelDownInfo.nameDateFormat !== undefined) {
        fileName += changeDateFormat(new Date(), this.itemInfo.excelDownInfo.nameDateFormat);
      }

      this.request.params.size = null;

      if(this.itemInfo.gridName === 'CLAIM_REFUND_GRID'){
        this.$api.getRefundsExcel(this.request).then(({data})=>{
          writeExcel(data, columns, fileName, this.itemInfo.excelDownInfo.formatters);
        })
        return;
      }

      this.$api.getClaimsExcel(this.request).then(({data})=>{
        writeExcel(data.contents, columns, fileName, this.itemInfo.excelDownInfo.formatters);
      })

    } else {
      alert(this.$t('COMMON_NOT_DATA'));
    }
  }

  private gridFunction(functionKey: any, params?: any) {
    if (params) {
      return (this.$refs.tuiGrid as Grid).invoke(functionKey, ...params);
    } else {
      return (this.$refs.tuiGrid as Grid).invoke(functionKey);
    }
  }

  private getCheckedRowKeys() {
    return (this.$refs.tuiGrid as Grid).invoke('getCheckedRowKeys');
  }
  private getRowAt(key: any) {
    return (this.$refs.tuiGrid as Grid).invoke('getRowAt', key);
  }
	
	public addCellClassName(rowKey, columnName, className) {
		const grid = this.$refs.tuiGrid as Grid;
		grid.invoke('addCellClassName', rowKey, columnName, className);
	}
	
  public getRowItems(rowKey: any): any {
    const grid = this.$refs.tuiGrid as Grid;
    const item: any = grid.invoke('getRow', rowKey);
    return item;
  }
  private check(rowKey: any): void {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('check', rowKey);
  }
  private uncheck(rowKey: any): void {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('uncheck', rowKey);
  }

  private getCheckedItems(propName: string) {
    const grid = this.$refs.tuiGrid as Grid;
    const items = grid.invoke('getCheckedRows').map(item => item[propName]);
    return items
  }
  private getData() {
    return (this.$refs.tuiGrid as Grid).invoke('getData');
  }
  // TODO
  private disableRowCheck(rowKey: any) {
    return (this.$refs.tuiGrid as any).invoke('disableRowCheck', rowKey);
  }
  private addRowGray(i: number) {
    const grid = this.$refs.tuiGrid as Grid;
    return grid.invoke('addRowClassName', i, 'gray');
  }
  private removeRowGray(i: number) {
    const grid = this.$refs.tuiGrid as Grid;
    return grid.invoke('removeRowClassName', i, 'gray');
  }
  private getCheckedRows(): any {
    const grid = this.$refs.tuiGrid as Grid;
    const rows = grid.invoke('getCheckedRows');
    return rows;
  }

  @Watch('option.excelDownInfo')
  updateExcelInfo(){
    this.itemInfo.excelDownInfo = this.option.excelDownInfo
  }

  private async initOption() {
    if (this.option) {
      Object.assign(this.itemInfo, this.option);
    }
    if (this.itemInfo.gridName) {
      this.defaultColumnsOrder = this.gridProps.columns.map((column: any, idx: number) => {
        return {
          columnName: column.name,
          displayOrder: idx + 1,
          visible: column.visible ?? true,
          showName: column.header
        };
      });
      if (this.gridProps.options.columnOptions && this.gridProps.options.columnOptions.frozenCount) {
        this.disabledCnt = this.gridProps.options.columnOptions.frozenCount;
      }
      let gridLayouts = await this.$api.getGridLayouts({params: {gridName: this.itemInfo.gridName as GridNameType}});
      gridLayouts.data.forEach((layoutInfo: any) => {
        let tempColumn = this.gridProps.columns.find((column: any) => layoutInfo.columnName === column.name);
        if (tempColumn) {
          if (layoutInfo.visible) {
            this.showColumns.push(tempColumn);
          }

          this.columnsOrder.push({
            columnName: layoutInfo.columnName,
            displayOrder: layoutInfo.displayOrder,
            visible: layoutInfo.visible,
            showName: tempColumn.header
          });
        }
      });
      if (this.columnsOrder.length < this.gridProps.columns.length) {
        this.gridProps.columns.forEach((column: any) => {
          if (this.columnsOrder.every((layoutInfo: any) => layoutInfo.columnName !== column.name)) {
            const intersectionItem = this.columnsOrder.find((dataItem) => dataItem.columnName === column.name);
            const defaultVisible = column.name !== 'orderOptionNo';
            const savedVisible = intersectionItem ? intersectionItem.visible : defaultVisible;
            savedVisible && this.showColumns.push(column);
            this.columnsOrder.push({
              columnName: column.name,
              displayOrder: this.columnsOrder.length + 1,
              visible: savedVisible,
              showName: column.header
            });
          }
        });
      }
    } else {
      this.showColumns = this.gridProps.columns;
    }
    this.initOver = true;
  }

  private async mounted() {
    await this.initOption();
    const grid = this.$refs.tuiGrid as Grid;
    
    this.bindGridEvent();
    
    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.$emit('resetData', ev.page);
        ev.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });

    if (this.itemInfo.onLoadSearch) {
      this.$emit('resetData', 1);
    }
    if (!this.data || this.data.length === 0) {
      grid.invoke('disable');
    }
  }

  updated() {
    const grid = this.$refs.tuiGrid as Grid;
    if (this.itemInfo.name === 'feePolicyDetailResultTable') {
      grid.invoke('addColumnClassName', 'finalSettlementAmt', 'orange')
      grid.invoke('addColumnClassName', 'finalAdjustedSettlementAmt', 'orange')
    }
  }

  private beforeCheckEvent = false
  private onCheck(event){
    if(this.beforeCheckEvent){
      return
    }

    if(this.hasGroup(event.rowKey)){
      const {rowKey} = event

      const groupRowKeys = this.getRowKeysOfGroupByClaimNo(rowKey).filter(groupRowKey => groupRowKey !== rowKey)
      this.toggleGroupCheck(groupRowKeys, 'check')

      return
    }
  }

  private onUnCheck(event){
    if(this.beforeCheckEvent){
      return
    }

    if(this.hasGroup(event.rowKey)){

      const {rowKey} = event

      const groupRowKeys = this.getRowKeysOfGroupByClaimNo(rowKey).filter(groupRowKey => groupRowKey !== rowKey)
      this.toggleGroupCheck(groupRowKeys, 'uncheck')

      return
    }
  }

  private hasGroup(rowKey){
    const grid = this.$refs.tuiGrid as Grid;
    const targetRow = grid.invoke('getRow', rowKey)
    const data = grid.invoke('getData')

    return data.filter(rowData => rowData.claimNo === targetRow.claimNo).length > 1
  }

  private getRowKeysOfGroupByClaimNo(rowKey){
    const grid = this.$refs.tuiGrid as Grid;
    const checkedRow = grid.invoke('getRow', rowKey)

    // depth가 깊은 응답데이터 + merge row된 데이터로 타입을 정의하기 어려움
    const groupRowKeys = this.data.reduce((acc, currentClaimData: any) =>
        currentClaimData.claimNo === checkedRow.claimNo
          ? [...acc, currentClaimData.rowKey]
          : acc
      , [])

    return groupRowKeys
  }

  private toggleGroupCheck(groupRowKeys: number[], nextCheckedStatus: 'check' | 'uncheck'){
    const grid = this.$refs.tuiGrid as Grid;

    groupRowKeys.forEach(rowKey => {
      this.beforeCheckEvent = true;
      grid.invoke(nextCheckedStatus, rowKey)
    })
    this.beforeCheckEvent = false
  }
  
  private bindGridEvent() {
    // check 시 클릭 이벤트 발동 안되도록
    this.gridRef.invoke('on', 'click', (gridProp) => {
      if ((gridProp as any).columnName !== '_checked') {
        this.onItemClicked && this.onItemClicked(gridProp);
      }
    });
  }

}
